import apiClient from "./base.service";

export default {
    async index(event_id, all = false) {
        let a = "";
        if(all) {
            a = "?all=true";
        }
        return await apiClient.get(`/event/${event_id}/team${a}`);
    },
    async get(event_id, id) {
        return await apiClient.get(`/event/${event_id}/team/${id}`);
    },
    async update(event_id, id, data) {
        return await apiClient.put(`/event/${event_id}/team/${id}`, data);
    },
    async create(event_id, data) {
        return await apiClient.post(`/event/${event_id}/team`, data);
    },
    async remove(event_id, id) {
        return await apiClient.delete(`/event/${event_id}/team/${id}`);
    }
}